import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutorunComponent } from '@myshared/autorun.component';
import { computed } from '@myshared/mobx-connector';
import { runInAction } from 'mobx';
import { firstValueFrom } from 'rxjs';
import { MessageService } from 'primeng/api';
import { I18NextService } from 'angular-i18next';

import { Model } from '../../app.model';
import { SessionKvPortOrderService } from '../../sessionkv/sessionkv-port-order.service';
import { PortOrderDraft } from '../../sessionkv/sessionkv-port-order';
import { CompanyService } from '../../company/company.service';
import { CustomerService } from '../../customer/customer.service';
import { SubscriptionService } from '../../subscription/subscription.service';
import { Subscription } from '../../subscription/subscription.model';
import { Company } from '../../company/company.model';
import { Customer } from '../../customer/customer.model';

@Component({
    selector: 'app-order-draft',
    templateUrl: './order-draft.component.html',
    standalone: false
})
export class OrderDraftComponent extends AutorunComponent implements OnInit {
    public drafts: PortOrderDraft[] = [];

    private myCompany: Company;
    private customers: Customer[];
    private subscriptions: Subscription[];

    constructor(
        private m: Model,
        private router: Router,
        private sessionKvPortOrderService: SessionKvPortOrderService,
        private messageService: MessageService,
        private customerService: CustomerService,
        private companyService: CompanyService,
        private subscriptionService: SubscriptionService,
        private i18n: I18NextService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.autorun(() => {
            this.customers = this.m.customer.customers;
            this.subscriptions = this.m.subscription.subscriptions;
        })
        this.drafts = await firstValueFrom(this.sessionKvPortOrderService.loadAll());
        this.myCompany = await firstValueFrom(this.companyService.getMyCompany());
        this.subscriptionService.refresh();

        if (this.m.account.currentUser.companyIsPartner) {
            this.customerService.refresh();
        }
    }

    @computed
    public get isLoaded() {
        return this.drafts && this.subscriptions && this.customers && this.myCompany;
    }

    public onDeleteDraft(draft: PortOrderDraft) {
        this.sessionKvPortOrderService.delete(draft.name).subscribe({
            next: () => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: (this.i18n.t('draft_deleted_successfully') as string)
                });

                runInAction(() => {
                    this.drafts = this.drafts.filter(d => d.name !== draft.name);
                });
            }
        });
    }

    public onContinueDraft(draft: PortOrderDraft) {
        const numberBlocks = draft.portOrder.numberBlocks;
        const step = numberBlocks?.$case === 'numberBlock' ? 'upload-port-form' : 'upload-phone-bill-form';

          this.router.navigate(['/do', 'phonenumbers', step, ''], {
            queryParams: {
                draftId: draft.name
            }
        });
    }

    public getInstancename(id: number) {
        const instance = this.subscriptions?.find(s => +s.appliance_id === +id); 
        return instance?.name;
    }

    public getContactName(id: number) {
        if (id !== 0) 
        {
            let foundCustomerCompany = this.customers?.find(c => c.contacts.find(cc => +cc.id === +id));
            let foundCustomer = foundCustomerCompany?.contacts?.find(cc => +cc.id === +id)
            return `${foundCustomer?.fullName} (${foundCustomerCompany?.name})`;
        }
    }
}
